import { initializeApp } from "firebase/app"
import { getAuth } from "firebase/auth"
import AppConstants from "./AppConstants"

const app = initializeApp(AppConstants.firebaseConfig)
const auth = getAuth(app)

export { auth }
